import React from 'react';
import { PDFViewer, Text } from '@react-pdf/renderer';
import MyDocument from "./doc";

const DocumentViewer = () => {

  const { prestador, beneficiario, solicitacao, procedimentos } = JSON.parse(localStorage.getItem("@bsi:relatorio"));
  
  const props = { prestador, beneficiario, solicitacao, procedimentos };

  return(
    <PDFViewer style={{width: "100%", height: "100vh", overflow: "hidden"}}>
        <MyDocument {...props} />
    </PDFViewer>
  );

}

export default DocumentViewer;
